export interface IEventName {
    id: string;
    event_name: string;
}
